import { Input, type InputProps } from '../inputs/Input';
import WithDisplayFormat, { type WithDisplayFormatProps } from '../withDisplayFormat';

export interface InputWithDisplayFormatProps extends Omit<WithDisplayFormatProps, 'render'> {}

const InputWithDisplayFormat = (props: InputWithDisplayFormatProps) => (
  <WithDisplayFormat<InputProps> {...props} render={(renderProps) => <Input {...renderProps} />} />
);

export default InputWithDisplayFormat;
